/** Release decision by Rafael, 2026-09-30. Existing grants are preserved.
 * Keep these providers discoverable, but unavailable in web/native workflows
 * until their real-account validation is complete and a new build ships.
 */
const COMING_SOON_PROVIDERS = new Set(["buffer", "onedrive"]);

export function isConnectionComingSoon(provider: string): boolean {
  return COMING_SOON_PROVIDERS.has(provider);
}
